<div class="credentials-wrapper">
  <div class="container">
    <div class="acc">
      <div class="divider">
        <span nz-typography><strong>Datasource accounts</strong></span>
        <button nz-button nzType="primary" nzDanger (click)="addImporter(tplContent, tplFooter)">
          <span nz-icon nzType="plus"></span>
          Add a Datasource
        </button>
      </div>
      <nz-tabset>
        <nz-tab nzTitle="Requests">
          <nz-skeleton [nzActive]="true" *ngIf="configurationRequestsLoading"></nz-skeleton>
          <nz-empty *ngIf="configurationRequests.length == 0 && !configurationRequestsLoading" nzNotFoundImage="simple"></nz-empty>
          <div class="configuration-requests">
            @for (configurationRequest of configurationRequests; track $index){
              <data-source [dataSource]="configurationRequest" [isDownloadImagePossible]="false" [isFooterVisible]="true"></data-source>
            }
          </div>
        </nz-tab>
        <nz-tab nzTitle="Active">
          <div class="accounts" style="padding: 16px">
            <nz-skeleton [nzActive]="true" *ngIf="accLoading"></nz-skeleton>
            <nz-empty *ngIf="!accLoading && accounts.length == 0" nzNotFoundImage="simple"></nz-empty>
            @if (!accLoading){
            <div *ngFor="let importerAccount of accounts">
              <div class="data-source-card">
                <div class="data-source-card-text">
                  <span class="card-text-title" nz-typography>{{importerAccount.display_name}}</span>
                  <span class="card-text-subtitle" nz-typography>{{importerAccount.supplier_system_partner_name}}</span>
                  <span class="card-text-subtitle" nz-typography nzType="secondary">{{importerAccount.supplier_system_partner_id }}</span>
                  <span class="card-text-subtitle" nz-typography nzType="secondary">{{importerAccount.supplier_partner_segment?  importerAccount.supplier_partner_segment: 'Segment not specified' }}</span>
                </div>
                <div class="data-source-card-logo">
                  <div class="logo-wrapper">
                    <img [src]="importerAccount.logo_url || 'assets/placeholder-image.png'" alt="Logo"/>
                  </div>
                </div>
                <div class="data-source-card-text">
                  <span class="card-text-title" nz-typography>{{importerAccount.partner_name}}</span>
                  <span class="card-text-subtitle" nz-typography nzType="secondary">{{importerAccount.supplier_partner_id }}</span>
                </div>
                <div class="data-source-info">
                  <div class="data-source-info-item">
                    <span>Credentials Ok?</span>
                    <ng-container [ngSwitch]="(importerAccount.id | verificationStatus : customer.pk : verificationKeys[importerAccount.id] | async)">
                      <span *ngSwitchCase="'unverified'" nz-tooltip [nzTooltipTitle]="'Verification in progress'" nz-typography nzType="secondary">
                        <span nz-icon nzType="info-circle" nzTheme="outline"></span>
                      </span>
                      <span *ngSwitchCase="'failed'" nz-tooltip [nzTooltipTitle]="'Verification failed'" nz-typography nzType="danger">
                        <span nz-icon nzType="warning" nzTheme="outline"></span>
                      </span>
                      <span *ngSwitchCase="'verified'" nz-tooltip [nzTooltipTitle]="'Verification successful'" nz-typography nzType="success">
                        <span nz-icon nzType="check-circle" nzTheme="outline"></span>
                      </span>
                      <span *ngSwitchCase="'blocked'" nz-tooltip [nzTooltipTitle]="'Verification blocked'" nz-typography nzType="danger">
                        <span nz-icon nzType="stop" nzTheme="outline"></span>
                      </span>
                    </ng-container>
                  </div>
                  <ng-container *ngIf="(importerAccount.id | verificationStatus : customer.pk : verificationKeys[importerAccount.id] | async) as verificationStatus">
                    <div class="data-source-info-item">
                      <span style="font-size: 16px; font-weight: 500">Enabled:</span>
                      <nz-switch
                        [ngModel]="importerAccount.enabled"
                        [nzLoading]="updatingEnabledAccountId === importerAccount.id"
                        [nzDisabled]="updatingEnabledAccountId === importerAccount.id || isVerificationNotVerified(verificationStatus)"
                        (ngModelChange)="onEnabledChange(importerAccount, $event)">
                      >
                      </nz-switch>
                    </div>
                    <div class="data-source-info-item">
                      <span style="font-size: 16px; font-weight: 500">Rotate:</span>
                      <nz-switch
                        [ngModel]="importerAccount.rotate"
                        [nzLoading]="updatingRotateAccountId === importerAccount.id"
                        [nzDisabled]="updatingRotateAccountId === importerAccount.id || isVerificationNotVerified(verificationStatus)"
                        (ngModelChange)="onRotateChange(importerAccount, $event)">
                      </nz-switch>
                    </div>
                    <div class="data-source-info-item" *ngIf="isSuperUser">
                      <button nz-button nzType="primary"
                              [nzLoading]="rotatingAccountId === importerAccount.id"
                              [disabled]="rotatingAccountId === importerAccount.id || isVerificationNotVerified(verificationStatus) || !importerAccount.rotate"
                              (click)="rotateCredentials(importerAccount)">
                        Rotate credentials
                      </button>
                    </div>
                  </ng-container>
                </div>
                <div class="data-source-card-footer-actions">
                  <button nz-button nzType="default" nzSize="large" (click)="deleteAccount(tplDeleteAccount, tplDeleteAccountFooter, importerAccount)">
                    <span nz-icon nzType="delete" nzTheme="outline"></span>
                  </button>
                  <button nz-button nzType="default" nzSize="large" (click)="openEditModal(tplEditAccount, tplEditAccountFooter, importerAccount)">
                    Configure
                  </button>
                  <button nz-button nzType="default" nzSize="large" (click)="openCredentialEditModal(tplEditCredentials, tplEditCredentialsFooter, importerAccount)">
                    Creds
                  </button>
                </div>
              </div>
            </div>
            }
          </div>
        </nz-tab>
      </nz-tabset>
    </div>
  </div>
</div>

<ng-template #tplContent let-ref="modalRef">
  <nz-spin [nzSpinning]="accountCRUD">
    <form nz-form #credentialForm="ngForm" nzLabelAlign="left">
      <nz-form-item>
        <nz-form-label nzRequired [nzSm]="24" [nzXs]="24">Customer supplier system</nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback
                         nzErrorTip="Supplier system is required" nzValidateStatus="{{supplierSystem == null ? 'error' : 'succes'}}">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select a supplier system"
                     [(ngModel)]="supplierSystem" name="supplierSystemAuthId" (ngModelChange)="selectSupplierSystem($event)">
            <nz-option *ngFor="let supplierSystem of availableSystemInfoList"
                       [nzLabel]="supplierSystem.supplier_system_partner_name"
                       [nzValue]="supplierSystem">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <div *ngIf="supplierSystem && importerAccount">
        <nz-form-item>
          <nz-form-label nzRequired [nzSm]="24" [nzXs]="24">Location</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback nzErrorTip="Location is required">
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select a location"
                       [(ngModel)]="importerAccount!.supplier_partner_id" name="supplierPartnerId">
              <nz-option
                *ngFor="let location of locations"
                [nzLabel]="location.partner_id + (location.partner_name ? ' (' + location.partner_name + ')' : '')"
                [nzValue]="location.partner_id">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="24" [nzXs]="24">Supplier partner segment</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback>
            <input [(ngModel)]="importerAccount!.supplier_partner_segment"
                   nz-input name="supplierPartnerSegment" placeholder="Supplier partner segment (optional)" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item *ngIf="!isUsingExistingGrpCredentials()">
          <nz-form-label nzRequired [nzSm]="24" [nzXs]="24">Display name</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback nzErrorTip="Display name is required">
            <input [(ngModel)]="importerAccount!.display_name"
                   nz-input name="displayName" placeholder="Display name" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="24" [nzXs]="24">Website</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24">
            <input [(ngModel)]="importerAccount!.website"
                   nz-input name="website" placeholder="Website (optional)" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="24" [nzXs]="24">Note</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24" [nzExtra]="(importerAccount!.note || '').length + '/255'">
            <textarea [(ngModel)]="importerAccount!.note"
                      nz-input name="note" placeholder="Note (optional)" maxlength="255" nzAutosize
                      style="min-height: 64px"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item *ngIf="isSuperUser">
          <nz-form-label [nzSm]="24" [nzXs]="24">Start time</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24">
            <input [(ngModel)]="importerAccount!.start_time"
                   nz-input name="startTime" type="time" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item *ngIf="isSuperUser">
          <nz-form-label [nzSm]="24" [nzXs]="24">Max duration (hours)</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24">
            <input [(ngModel)]="importerAccount!.max_duration_hours"
                   nz-input name="maxDurationHours" type="number" min="1" />
          </nz-form-control>
        </nz-form-item>
<!--        <nz-form-item>-->
<!--          <nz-form-label [nzSm]="24" [nzXs]="24">Rotate</nz-form-label>-->
<!--          <nz-form-control [nzSm]="24" [nzXs]="24">-->
<!--            <nz-switch [(ngModel)]="importerAccount!.rotate" name="rotate"></nz-switch>-->
<!--          </nz-form-control>-->
<!--        </nz-form-item>-->
        <ng-container *ngTemplateOutlet="settingsFieldsTpl; context: {
          fields: createSettingsFields,
          settings: importerAccount!.settings,
          namePrefix: 'createSettings_',
          superUser: isSuperUser
        }"></ng-container>
        <ng-container *ngIf="supplierSystem.supplier_system_auth_id === 'grp' && existingGrpAccounts.length > 0; else nonGrpOrNoExisting">
          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzXs]="24">GRP Credentials</nz-form-label>
            <nz-form-control [nzSm]="24" [nzXs]="24">
              <nz-radio-group [(ngModel)]="grpCredentialOption" name="grpCredentialOption" (ngModelChange)="onGrpOptionChange($event)">
                <label nz-radio nzValue="existing">Use existing credentials</label>
                <label nz-radio nzValue="new">Create new credentials</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item *ngIf="grpCredentialOption === 'existing'">
            <nz-form-label nzRequired [nzSm]="24" [nzXs]="24">Select existing credentials</nz-form-label>
            <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback nzErrorTip="Please select existing credentials">
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select credentials"
                         [(ngModel)]="selectedGrpCredentialsId" name="grpExistingCredentialsId"
                         (ngModelChange)="onGrpExistingCredentialSelect($event)">
                <nz-option
                  *ngFor="let grpAccount of existingGrpAccounts"
                  [nzLabel]="grpAccount.supplier_system_partner_name + ' — ' + (grpAccount.partner_name || grpAccount.supplier_partner_id)"
                  [nzValue]="grpAccount.id">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <ng-container *ngIf="grpCredentialOption === 'new'">
            <ng-container *ngTemplateOutlet="createSecretFieldsTpl"></ng-container>
          </ng-container>
        </ng-container>
        <ng-template #nonGrpOrNoExisting>
          <ng-container *ngTemplateOutlet="createSecretFieldsTpl"></ng-container>
        </ng-template>
      </div>
    </form>
  </nz-spin>
</ng-template>
<ng-template #tplFooter let-ref="modalRef">
  <button nz-button (click)="closeModal(ref)" [disabled]="accountCRUD">Cancel</button>
  <button nz-button (click)="newCredentials(ref)" nzDanger nzType="primary" [nzLoading]="accountCRUD"
          [disabled]="isCreateDisabled() || accountCRUD">
    <span nz-icon nzType="plus"></span>
    Add a importer
  </button>
</ng-template>

<ng-template #tplEditAccount let-ref="modalRef">
  <nz-spin [nzSpinning]="accountCRUD">
    <form nz-form nzLabelAlign="left" *ngIf="editingAccount">
      <nz-form-item>
        <nz-form-label nzRequired [nzSm]="24" [nzXs]="24">Display name</nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback nzErrorTip="Display name is required">
          <input [(ngModel)]="editingAccount!.display_name"
                 nz-input name="editDisplayName" placeholder="Display name" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24">Website</nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24">
          <input [(ngModel)]="editingAccount!.website"
                 nz-input name="editWebsite" placeholder="Website (optional)" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24">Note</nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" [nzExtra]="(editingAccount!.note || '').length + '/255'">
          <textarea [(ngModel)]="editingAccount!.note"
                    nz-input name="editNote" placeholder="Note (optional)" maxlength="255" nzAutosize
                    style="min-height: 64px"></textarea>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="isSuperUser">
        <nz-form-label [nzSm]="24" [nzXs]="24">Start time</nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24">
          <input [(ngModel)]="editingAccount!.start_time"
                 nz-input name="editStartTime" type="time" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="isSuperUser">
        <nz-form-label [nzSm]="24" [nzXs]="24">Max duration (hours)</nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24">
          <input [(ngModel)]="editingAccount!.max_duration_hours"
                 nz-input name="editMaxDurationHours" type="number" min="1" />
        </nz-form-control>
      </nz-form-item>
      <ng-container *ngTemplateOutlet="settingsFieldsTpl; context: {
        fields: editSettingsFields,
        settings: editingAccount!.settings,
        namePrefix: 'editSettings_',
        superUser: isSuperUser
      }"></ng-container>
      <p *ngIf="error" nz-typography nzType="danger">{{ error }}</p>
    </form>
  </nz-spin>
</ng-template>
<ng-template #tplEditAccountFooter let-ref="modalRef">
  <button nz-button (click)="closeEditModal(ref)" [disabled]="accountCRUD">Cancel</button>
  <button nz-button nzType="primary" [nzLoading]="accountCRUD"
          [disabled]="isSaveDisabled() || accountCRUD"
          (click)="saveCredentials(ref)">
    <span nz-icon nzType="save"></span>
    Save
  </button>
</ng-template>

<ng-template #tplDeleteAccount let-ref="modalRef">
  <nz-spin [nzSpinning]="accountCRUD">
    <p>
      This will <b>permanently remove</b> the importer account from the system. This cannot be undone.
    </p>
    <p>Enter "Delete" and the account name into the field below to proceed:</p>
    <form nz-form>
      <nz-form-item>
        <nz-form-control nzHasFeedback nzErrorTip="Feature name is required">
          <input class="form-item-bordered" nz-input [(ngModel)]="deleteTextValue" name="feature_delete_text"
                 required="true" [placeholder]="'Delete ' + ref.getConfig().nzData.supplier_system_partner_id"/>
        </nz-form-control>
      </nz-form-item>
    </form>
  </nz-spin>
</ng-template>
<ng-template #tplDeleteAccountFooter let-ref="modalRef">
  <button nz-button (click)="ref.close()" [disabled]="accountCRUD">Cancel</button>
  <button nz-button (click)="delete(ref)" nzDanger nzType="primary" [nzLoading]="accountCRUD"
          [disabled]="!isDeleteConfirmed(ref) || accountCRUD"
  >Delete</button>
</ng-template>

<ng-template #tplEditCredentials let-ref="modalRef">
  <nz-spin [nzSpinning]="accountCRUD">
    <form nz-form nzLabelAlign="left">
      <ng-container *ngIf="editingCredentialsSupplierSystem?.supplier_system_auth_id === 'grp' && editingCredentialsExistingGrpAccounts.length > 0; else credentialsNonGrpOrNoExisting">
        <nz-form-item>
          <nz-form-label [nzSm]="24" [nzXs]="24">GRP Credentials</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24">
            <nz-radio-group [(ngModel)]="editingCredentialsGrpOption" name="editingCredentialsGrpOption" (ngModelChange)="onCredentialsGrpOptionChange($event)">
              <label nz-radio nzValue="existing">Link to different credentials</label>
              <label nz-radio nzValue="new">Edit credentials</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item *ngIf="editingCredentialsGrpOption === 'existing'">
          <nz-form-label nzRequired [nzSm]="24" [nzXs]="24">Select existing credentials</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback nzErrorTip="Please select existing credentials">
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select credentials"
                       [(ngModel)]="editingCredentialsSelectedGrpId" name="editingCredentialsExistingGrpId"
                       (ngModelChange)="onCredentialsGrpExistingSelect($event)">
              <nz-option
                *ngFor="let grpAccount of editingCredentialsExistingGrpAccounts"
                [nzLabel]="grpAccount.supplier_system_partner_name + ' — ' + (grpAccount.partner_name || grpAccount.supplier_partner_id)"
                [nzValue]="grpAccount.id">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <ng-container *ngIf="editingCredentialsGrpOption === 'new'">
          <nz-form-item *ngFor="let field of editingCredentialsSupplierSystem.secret_schema">
            <nz-form-label nzRequired [nzSm]="24" [nzXs]="24">{{ secretFieldLabel(field) }}</nz-form-label>
            <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback>
              <input nz-input
                     [(ngModel)]="editingCredentialsData[field]"
                     [name]="'editingCredentials_' + field"
                     [placeholder]="field" />
            </nz-form-control>
          </nz-form-item>
        </ng-container>
      </ng-container>
      <ng-template #credentialsNonGrpOrNoExisting>
        <nz-form-item *ngFor="let field of editingCredentialsSupplierSystem?.secret_schema">
          <nz-form-label nzRequired [nzSm]="24" [nzXs]="24">{{ secretFieldLabel(field) }}</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback>
            <input nz-input
                   [(ngModel)]="editingCredentialsData[field]"
                   [name]="'editingCredentials_' + field"
                   [placeholder]="field" />
          </nz-form-control>
        </nz-form-item>
      </ng-template>
      <p *ngIf="error" nz-typography nzType="danger">{{ error }}</p>
    </form>
  </nz-spin>
</ng-template>
<ng-template #tplEditCredentialsFooter let-ref="modalRef">
  <button nz-button (click)="closeCredentialEditModal(ref)" [disabled]="accountCRUD">Cancel</button>
  <button nz-button nzType="primary" [nzLoading]="accountCRUD"
          [disabled]="isCredentialsSaveDisabled() || accountCRUD"
          (click)="saveCredentialsEdit(ref)">
    <span nz-icon nzType="save"></span>
    Save
  </button>
</ng-template>

<!-- Dynamic credential fields for the create form, rendered from a supplier system `secret_schema`. -->
<ng-template #createSecretFieldsTpl>
  <nz-form-item *ngFor="let field of supplierSystem?.secret_schema">
    <nz-form-label nzLabelAlign="left" nzRequired [nzSm]="24" [nzXs]="24">{{ secretFieldLabel(field) }}</nz-form-label>
    <nz-form-control [nzSm]="24" [nzXs]="24" nzHasFeedback>
      <input nz-input
             [(ngModel)]="importerAccount!.secrets![field]"
             [name]="'secret_' + field"
             [placeholder]="field" />
    </nz-form-control>
  </nz-form-item>
</ng-template>

<!-- Dynamic settings form, rendered from a supplier system `settings_schema`. -->
<ng-template #settingsFieldsTpl let-fields="fields" let-settings="settings" let-namePrefix="namePrefix" let-superUser="superUser">
  <ng-container *ngFor="let field of fields; trackBy: trackBySettingsField">
    <ng-container *ngIf="!field.superUserOnly || superUser">

      <ng-container *ngIf="field.control === 'object'; else scalarField">
        <nz-form-item *ngFor="let child of field.children; trackBy: trackBySettingsField">
          <nz-form-label nzLabelAlign="left" [nzRequired]="field.required && child.required" [nzSm]="24" [nzXs]="24">
            {{ field.label }} — {{ child.label }}
          </nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24">
            <nz-switch *ngIf="child.control === 'boolean'; else objChildInput"
                       [(ngModel)]="settings[field.key][child.key]"
                       [name]="namePrefix + field.key + '_' + child.key"></nz-switch>
            <ng-template #objChildInput>
              <input nz-input
                     [type]="child.control === 'number' ? 'number' : (child.control === 'date' ? 'date' : 'text')"
                     [(ngModel)]="settings[field.key][child.key]"
                     [name]="namePrefix + field.key + '_' + child.key"
                     [placeholder]="child.label" />
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </ng-container>

      <ng-template #scalarField>
        <nz-form-item>
          <nz-form-label nzLabelAlign="left" [nzRequired]="field.required" [nzSm]="24" [nzXs]="24">{{ field.label }}</nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24">
            <ng-container [ngSwitch]="field.control">
              <nz-switch *ngSwitchCase="'boolean'"
                         [(ngModel)]="settings[field.key]" [name]="namePrefix + field.key"></nz-switch>
              <nz-select *ngSwitchCase="'enum'"
                         [(ngModel)]="settings[field.key]" [name]="namePrefix + field.key"
                         [nzPlaceHolder]="'Select ' + field.label">
                <nz-option *ngFor="let opt of field.enumOptions" [nzValue]="opt" [nzLabel]="opt"></nz-option>
              </nz-select>
              <nz-select *ngSwitchCase="'list'" nzMode="tags"
                         [(ngModel)]="settings[field.key]" [name]="namePrefix + field.key"
                         [nzPlaceHolder]="'Enter ' + field.label"></nz-select>
              <input *ngSwitchCase="'date'" nz-input type="date"
                     [(ngModel)]="settings[field.key]" [name]="namePrefix + field.key" />
              <input *ngSwitchCase="'number'" nz-input type="number"
                     [(ngModel)]="settings[field.key]" [name]="namePrefix + field.key" />
              <input *ngSwitchDefault nz-input type="text"
                     [(ngModel)]="settings[field.key]" [name]="namePrefix + field.key"
                     [placeholder]="field.label" />
            </ng-container>
          </nz-form-control>
        </nz-form-item>
      </ng-template>

    </ng-container>
  </ng-container>
</ng-template>
